import React from 'react'
import { Store } from 'pullstate'

export const stateStore = new Store({
   chain : "bsc" 
})
   

